"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";

import { localToday } from "@/lib/calendar/week";
import type { DashboardEntry } from "@/lib/dashboard/server";

interface DashboardResponse {
  entries: DashboardEntry[];
  todayIso: string;
}

export function useDashboard(enabled: boolean) {
  const locale = useLocale();

  return useQuery<DashboardResponse>({
    queryKey: ["dashboard", locale],
    queryFn: async () => {
      const res = await fetch(`/api/dashboard?locale=${locale}&today=${localToday()}`);
      if (!res.ok) throw new Error("Failed to fetch dashboard");
      return res.json();
    },
    enabled,
    staleTime: 0,
  });
}
